// extracted by mini-css-extract-plugin
export default {"tabs":"tabs_tabs__HUEZQ","tabs__titles":"tabs_tabs__titles__QWHce","tabTitle":"tabs_tabTitle__WZmkJ","tabTitleActive":"tabs_tabTitleActive__I5Htz","disabled":"tabs_disabled__cJnQv"};